module.exports = __webpack_public_path__ + "img/gold-icon.76fd530a.png";